import { useMemo } from 'react';
import { useShop } from '@frontastic-engbers/lib';
import { mapShop } from '@frontastic-engbers/helpers/utils/mapShop';

export const useCurrentShopName = () => {
  const currentShop = useShop();
  return useMemo(() => mapShop(currentShop), [currentShop]);
};
